import { Injectable } from '@angular/core';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { ThreadFilterGuiModel } from '../../core/models/thread-filter-gui.model';
import { SatisfactionDTO } from '../../core/models/dto/satisfaction.dto';

@Injectable({
    providedIn: 'root',
})
export class ThreadFilterService {
    static activeThreadFilter: ThreadFilterGuiModel;
    static collapseOptions = { takeReplies: 0, isCollapsed: true };
    static isFilterSet: boolean;
    static isPrinting = false;
    static hasVisibleReplies = true;
    static messageThreadForPrinting: (ThreadElementDTO | SatisfactionDTO)[] = [];
    static searchQuery: string;
    static updateStamp: number; // need to make replies pipe to know then message thread was updated

    static resetFilters(): void {
        this.activeThreadFilter = undefined;
        this.collapseOptions = { takeReplies: 0, isCollapsed: true };
        this.hasVisibleReplies = true;
        this.searchQuery = null;
        this.isPrinting = false;
        this.messageThreadForPrinting = [];
    }

    static refreshUpdateStamp(): void {
        this.updateStamp = new Date().getTime();
    }

    static showAllReplies(messageThreadLength: number): void {
        this.collapseOptions.isCollapsed = false;
        this.collapseOptions.takeReplies = messageThreadLength;
        this.refreshUpdateStamp();
    }

    static updateFilterSet(isFilterSet: boolean): void {
        this.isFilterSet = isFilterSet;
    }
}
